import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import { withTranslation } from '../../translations/i18n';
import withIdContext from '../../decorators/withIdContext';

const ApplyAction = ({
  t,
  label,
  type,
  disabled,
  onClick,
}) => (
  <Button
    bStyle="primary"
    type={type}
    disabled={disabled}
    onClick={onClick}
  >
    {label || t('Apply')}
  </Button>
);

ApplyAction.propTypes = {
  t: PropTypes.func.isRequired,
  /** Button label */
  label: PropTypes.string,
  /** Button type */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /** Disable button */
  disabled: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  onClick: PropTypes.func.isRequired,
};

ApplyAction.defaultProps = {
  label: null,
  type: 'button',
  disabled: false,
};

export const ApplyActionBase = ApplyAction;

const ApplyActionTranslated = withTranslation()(ApplyAction);
export default withIdContext()(ApplyActionTranslated);
